module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William G. Dever\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("William G. Dever")]), _vm._v(" is professor emeritus of Near Eastern archaeology and anthropology at the University of Arizona in Tucson. He has served as director of the Nelson Glueck School of Biblical Archaeology in Jerusalem, as director of the W. F. Albright Institute of Archaeological Research in Jerusalem, and as a visiting professor at universities around the world. He has spent thirty years conducting archaeological excavations in the Near East, resulting in a large body of award-winning fieldwork.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qnKXmq/tc-custom/9781467459495.jpg?1728851824909",
      "alt": "This image is the cover for the book Has Archaeology Buried the Bible?"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Has Archaeology Buried the Bible?\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Bringing the Bible and ancient Israel into a new and brighter light")])]), _c('p', [_vm._v("In the last several decades, archaeological evidence has dramatically illuminated ancient Israel. However, instead of proving the truth of the Bible—as an earlier generation had confidently predicted—the new discoveries have forced us to revise much of what was thought to be biblical truth, provoking an urgent question: If the biblical stories are not always true historically, what, if anything, is still salvageable of the Bible’s ethical and moral values? ")]), _c('p', [_c('i', [_vm._v("Has Archaeology Buried the Bible?")]), _vm._v(" simplifies these complex issues and summarizes the new, archaeologically attested ancient Israel, period by period (ca. 1200–600 BCE). But it also explores in detail how a modern, critical reader of the Bible can still find relevant truths by which to live.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0